module.exports = __webpack_public_path__ + "static/media/30-2.fb3f94df.mp3";